module.exports = __webpack_public_path__ + "media/images/pc/visit_reserve/kv-cafe-855e4c32f761e18bba9091027a0e84ad.png";